const themeModeInitialState = {
  themeMode: '',
};

const themeInitialState = {
  themeColor: '',
};

const strokeInitialState = {
  borderStroke: '',
};

const bodyGradientInitialState = {
  gradientColor: '',
};

const boxLayoutInitialState = {
  boxLayout: '',
};

const monochromeInitialState = {
  monochrome: '',
};

const borderRadiusInitialState = {
  borderRadius: '',
};

const iconColorInitialState = {
  iconColor: '',
};

const cardShadowInitialState = {
  cardShadow: '',
};

const sidebarDarkInitialState = {
  sidebarDark: 'none',
};

const headerDarkInitialState = {
  headerDark: 'none',
};


export const themeModeReducer = (state = themeModeInitialState, action) => {
  switch (action.type) {
    case 'SET_THEME_MODE':
      return {
        ...state,
        themeMode: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        themeMode: action.payload?.themeMode || state.themeMode,
      };
    default:
      return state;
  }
};

export const themeReducer = (state = themeInitialState, action) => {
  switch (action.type) {
    case 'SET_THEME_COLOR':
      return {
        ...state,
        themeColor: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        themeColor: action.payload?.themeColor || state.themeColor,
      };
    default:
      return state;
  }
};

export const strokeReducer = (state = strokeInitialState, action) => {
  switch (action.type) {
    case 'SET_BORDER_STROKE':
      return {
        ...state,
        borderStroke: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        borderStroke: action.payload?.borderStroke || state.borderStroke,
      };
    default:
      return state;
  }
};

export const bodyGradientReducer = (state = bodyGradientInitialState, action) => {
  switch (action.type) {
    case 'SET_BODY_GRADIENT':
      return {
        ...state,
        gradientColor: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        gradientColor: action.payload?.gradientColor || state.gradientColor,
      };
    default:
      return state;
  }
};

export const boxLayoutReducer = (state = boxLayoutInitialState, action) => {
  switch (action.type) {
    case 'SET_BOX_LAYOUT':
      return {
        ...state,
        boxLayout: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        boxLayout: action.payload?.boxLayout || state.boxLayout,
      };
    default:
      return state;
  }
};

export const monochromeReducer = (state = monochromeInitialState, action) => {
  switch (action.type) {
    case 'SET_MONOCHROME':
      return {
        ...state,
        monochrome: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        monochrome: action.payload?.monochrome || state.monochrome,
      };
    default:
      return state;
  }
};

export const borderRadiusReducer = (state = borderRadiusInitialState, action) => {
  switch (action.type) {
    case 'SET_BORDER_RADIUS':
      return {
        ...state,
        borderRadius: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        borderRadius: action.payload?.borderRadius || state.borderRadius,
      };
    default:
      return state;
  }
};

export const cardShadowReducer = (state = cardShadowInitialState, action) => {
  switch (action.type) {
    case 'SET_CARD_SHADOW':
      return {
        ...state,
        cardShadow: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        cardShadow: action.payload?.cardShadow || state.cardShadow,
      };
    default:
      return state;
  }
};

export const iconColorReducer = (state = iconColorInitialState, action) => {
  switch (action.type) {
    case 'SET_ICON_COLOR':
      return {
        ...state,
        iconColor: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        iconColor: action.payload?.iconColor || state.iconColor,
      };
    default:
      return state;
  }
};

export const sidebarDarkReducer = (state = sidebarDarkInitialState, action) => {
  switch (action.type) {
    case 'SET_SIDEBAR_DARK':
      return {
        ...state,
        sidebarDark: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        sidebarDark: action.payload?.sidebarDark || state.sidebarDark,
      };
    default:
      return state;
  }
};

export const headerDarkReducer = (state = headerDarkInitialState, action) => {
  switch (action.type) {
    case 'SET_HEADER_DARK':
      return {
        ...state,
        headerDark: action.payload,
      };
    case 'SET_THEME_SETTINGS_DATA':
      return {
        ...state,
        headerDark: action.payload?.headerDark || state.headerDark,
      };
    default:
      return state;
  }
};